// import axios from "axios";
import api from "../config/api";
import { SalaryMaster } from "../types/salaryMaster";

const API_URL = "/salaryMaster";

export const getAllSalaries = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getSalaryById = (employeeId: String) =>
  api.get(`${API_URL}/?id=${employeeId}`);

export const createSalary = (data: SalaryMaster) =>
  api.post(`${API_URL}/`, data);

export const updateSalary = (id: number, data: SalaryMaster) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteSalary = (id: number) => api.delete(`${API_URL}/?id=${id}`);
